import { LiturgyItem } from "./types";

export const getOpeningResponses = (omitFirst: boolean) => {
    const result: LiturgyItem[] = [];

    if (!omitFirst) {
        result.push({
            type: "chant",
            boldMode: "none",
            tone: "5.1",
            pointedText: {
                clef: "c7",
                verses: [
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "O",
                                        notes: ["1"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "Lord,",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "o",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "pen",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "thou",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "our",
                                        notes: ["2"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "lips.",
                                        notes: ["3"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        });

        result.push({
            type: "chant",
            boldMode: "all",
            tone: "5.1",
            pointedText: {
                clef: "c7",
                verses: [
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "And",
                                        notes: ["1"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "our",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "mouth",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "shall",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "show",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "forth",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "thy",
                                        notes: ["2"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "praise.",
                                        notes: ["3"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        });
    }

    result.push({
        type: "chant",
        boldMode: "none",
        tone: "5.1",
        pointedText: {
            clef: "c7",
            verses: [
                {
                    secondHalf: [
                        {
                            syllables: [
                                {
                                    text: "O",
                                    notes: ["5"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "God,",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "make",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "speed",
                                    notes: ["8"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "to",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "save",
                                    notes: ["6"],
                                    long: true,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "us.",
                                    notes: ["7"],
                                    long: true,
                                    dotBefore: false,
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    });

    result.push({
        type: "chant",
        boldMode: "all",
        tone: "5.1",
        pointedText: {
            clef: "c7",
            verses: [
                {
                    secondHalf: [
                        {
                            syllables: [
                                {
                                    text: "O",
                                    notes: ["5"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "Lord,",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "make",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "haste",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "to",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "help",
                                    notes: ["6"],
                                    long: true,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "us.",
                                    notes: ["7"],
                                    long: true,
                                    dotBefore: false,
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    });

    result.push({
        type: "chant",
        boldMode: "none",
        tone: "5.1",
        pointedText: {
            clef: "c7",
            verses: [
                {
                    secondHalf: [
                        {
                            syllables: [
                                {
                                    text: "Glo",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                                {
                                    text: "ry",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "be",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "to",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "the",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "Fa",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                                {
                                    text: "ther,",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "and",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "to",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "the",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "Son,",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "and",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "to",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "the",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "Ho",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                                {
                                    text: "ly",
                                    notes: ["6"],
                                    long: true,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "Ghost.",
                                    notes: ["7"],
                                    long: true,
                                    dotBefore: false,
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    });

    result.push({
        type: "chant",
        boldMode: "all",
        tone: "5.1",
        pointedText: {
            clef: "c7",
            verses: [
                {
                    secondHalf: [
                        {
                            syllables: [
                                {
                                    text: "As",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "it",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "was",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "in",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "the",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "be",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                                {
                                    text: "ginn",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                                {
                                    text: "ing,",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "is",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "now,",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "and",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "e",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                                {
                                    text: "ver",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "shall",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "be,",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "world",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "with",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                                {
                                    text: "out",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "end.",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },

                        {
                            syllables: [
                                {
                                    text: "A",
                                    notes: ["6"],
                                    long: true,
                                    dotBefore: false,
                                },
                                {
                                    text: "men.",
                                    notes: ["7"],
                                    long: true,
                                    dotBefore: false,
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    });

    result.push({
        type: "chant",
        boldMode: "none",
        tone: "5.1",
        pointedText: {
            clef: "c7",
            verses: [
                {
                    secondHalf: [
                        {
                            syllables: [
                                {
                                    text: "Praise",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "ye",
                                    notes: ["7", "8"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "the",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "Lord.",
                                    notes: ["7", "6"],
                                    long: true,
                                    dotBefore: false,
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    });

    result.push({
        type: "chant",
        boldMode: "all",
        tone: "5.1",
        pointedText: {
            clef: "c7",
            verses: [
                {
                    secondHalf: [
                        {
                            syllables: [
                                {
                                    text: "The",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "Lord's",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "Name",
                                    notes: ["7", "8"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "be",
                                    notes: ["7"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "prais-",
                                    notes: ["7", "6"],
                                    long: false,
                                    dotBefore: false,
                                },
                                {
                                    text: "ed.",
                                    notes: ["6"],
                                    long: true,
                                    dotBefore: false,
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    });

    return result;
};
